<template>
  <div>

      <iframe src="https://docs.google.com/document/d/e/2PACX-1vRsENj3_h2q7uOmNhy6w8hnQeWU1RqplQqNYWPv2Xawvh3pKew1SZFrfnVkv9N1swX9feOSOJjtafGH/pub?embedded=true" width="100%" height="650px"></iframe>

  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>